import React, { Component } from 'react';
import UnknownError from './UnknownError';
class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: null,
        };
        this.componentDidCatch = (error) => {
            this.setState({ error });
        };
    }
    render() {
        const { children, messages, history, buttonProps } = this.props;
        const { error } = this.state;
        return error ? (React.createElement(UnknownError, { history: history, translations: messages, buttonProps: buttonProps })) : (children);
    }
}
ErrorBoundary.getDerivedStateFromError = (error) => {
    return { error };
};
export default ErrorBoundary;
